export default __webpack_public_path__ + "static/documentary2-ef6a8e7a500b0883737e81860fc50e9c.jpg";